<div class="light-pdf-preview" [attr.aria-busy]="loading ? true : null">
  <div #pageHost class="light-pdf-preview__pages"></div>

  <div *ngIf="loading" class="light-pdf-preview__loading" aria-live="polite">
    <i class="fa-duotone fa-spinner-third fa-spin text-primary" aria-hidden="true"></i>
    <span>Loading preview…</span>
  </div>

  <div
    *ngIf="loadError && !loading"
    class="light-pdf-preview__error"
    role="alert"
  >
    Could not render the PDF preview. Try Replace to upload again.
  </div>
</div>
